export default { release:'25.10.6' }
